import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPChooseYourOptionsUIInner from './PDPChooseYourOptionsUI';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptionsPlaceholder';
const PDPChooseYourOptionsInner = t0 => {
  const $ = _c(26);
  const {
    isEditOrder: t1,
    mode: t2,
    onMoreMaterialsClick,
    setMarxentSelectedFabric,
    slug
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const {
    loading: basicDetailsLoading,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    loading,
    data: t3
  } = usePDPOptions();
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    options: t5,
    upholsteryOptionId,
    stock: t6
  } = t4;
  let t7;
  if ($[2] !== t5) {
    t7 = t5 === undefined ? [] : t5;
    $[2] = t5;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const options = t7;
  let t8;
  if ($[4] !== t6) {
    t8 = t6 === undefined ? {} : t6;
    $[4] = t6;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const stock = t8;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    data: t9
  } = usePDPStockAvailability();
  const {
    isMarkedOOSOrDiscontinued,
    isStockLoading
  } = t9;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let t10;
  if ($[6] !== basicDetailsData) {
    t10 = basicDetailsData ?? {};
    $[6] = basicDetailsData;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const {
    id,
    efg_flag,
    custom_properties: t11
  } = t10;
  let t12;
  if ($[8] !== t11) {
    t12 = t11 === undefined ? {} : t11;
    $[8] = t11;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  const {
    option_selector: t13
  } = t12;
  const optionSelector = t13 === undefined ? "" : t13;
  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const t14 = !efg_flag;
  const t15 = loading || basicDetailsLoading || isMarkedOOSOrDiscontinued && isStockLoading;
  const t16 = isRTSTab ? stock?.stockOptions : options;
  const t17 = stock?.selectionValidity;
  let t18;
  if ($[10] !== id || $[11] !== isDecideLaterTab || $[12] !== isEditOrder || $[13] !== isRTSTab || $[14] !== mode || $[15] !== onMoreMaterialsClick || $[16] !== optionSelector || $[17] !== pdpIsModularBYOProduct || $[18] !== setMarxentSelectedFabric || $[19] !== slug || $[20] !== t14 || $[21] !== t15 || $[22] !== t16 || $[23] !== t17 || $[24] !== upholsteryOptionId) {
    t18 = <PDPChooseYourOptionsUIInner pdpIsModularBYOProduct={pdpIsModularBYOProduct} isDecideLaterTab={isDecideLaterTab} isEditOrder={isEditOrder} isFFG={t14} isRTSTab={isRTSTab} loading={t15} mode={mode} onMoreMaterialsClick={onMoreMaterialsClick} options={t16} productId={id} selectionValidity={t17} slug={slug} optionSelector={optionSelector} upholsteryOptionId={upholsteryOptionId} setMarxentSelectedFabric={setMarxentSelectedFabric} />;
    $[10] = id;
    $[11] = isDecideLaterTab;
    $[12] = isEditOrder;
    $[13] = isRTSTab;
    $[14] = mode;
    $[15] = onMoreMaterialsClick;
    $[16] = optionSelector;
    $[17] = pdpIsModularBYOProduct;
    $[18] = setMarxentSelectedFabric;
    $[19] = slug;
    $[20] = t14;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
    $[24] = upholsteryOptionId;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
};
PDPChooseYourOptionsInner.propTypes = {
  isEditOrder: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string
};
const PDPChooseYourOptions = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPChooseYourOptionsPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPChooseYourOptionsInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPChooseYourOptions;